'use client';
import { FAQ_BIKE_DATA, FAQ_CAR_DATA } from '@/components/accordion';
import { useGeneralStore } from '@/providers/general-store-provider';
import Accordion from './accordion.component';

import { TYPE_BIKE } from '@/helpers/constants';
import { useMemo } from 'react';
import './accordion.scss';

export default function AccordionList() {
    const { vehicleType } = useGeneralStore();

    const faq = useMemo(() => (vehicleType == TYPE_BIKE ? FAQ_BIKE_DATA : FAQ_CAR_DATA), [vehicleType]);

    const listFAQ = useMemo(
        () => faq?.map((item, index) => <Accordion key={index} title={item.questionJSX} content={item.answerJSX} />),
        [faq],
    );

    return listFAQ;
}
